module.exports = __webpack_public_path__ + "img/customer-satisfaction.e5a5dcf.svg";